import { BaseModel, fillOwnProperties, registerModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'

export default class DigitalLectureFilterValue extends BaseModel {
  static override constructorName = 'DigitalLectureFilterValue'

  id: number = 0
  name: string = ''

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)
    }
  }
}

registerModel(DigitalLectureFilterValue)
